import React from 'react'
import Hero from '../components/Hero'
import Layout from '../components/Layout'
import LandingPage from '../components/LandingPage'
import Projects from '../components/Projects'
import Newsletter from '../components/Newsletter'
import { graphql } from 'gatsby'
import SEO from '../components/SEO'
import FAQ from './faq'
import AuthContextProvider from '../context/AuthContext'

const IndexPage = ({ data }) => {
  const {
    allMdx: { nodes: projects },
  } = data
  return (
    <section>
      <AuthContextProvider>
        <Hero showPerson />
        <LandingPage />
        <Projects projects={projects} title="recent projects" />
        <Newsletter />
        <FAQ />
      </AuthContextProvider>
    </section>
  )
}

export const query = graphql`
  {
    allMdx(sort: { fields: frontmatter___date, order: DESC }, limit: 3) {
      nodes {
        excerpt
        frontmatter {
          slug
          date(formatString: "MMM Do, YYYY")
          author
          category
          readTime
          difficulty
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        id
      }
    }
  }
`

export default IndexPage
